import { CreateEntityViewLogRequestDTO, EntityLogDTO, ENTITY_LOG_ENTITY_TYPES } from '@pya-mms/common';
import axios, { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';
import useProtectRoute from './useProtectRoute';

const createViewEntityLog = async ({
  entityId,
  action,
  entityType,
}: {
  entityId: string;
  action: string;
  entityType: ENTITY_LOG_ENTITY_TYPES;
}) => {
  const { data } = await axios.post<CreateEntityViewLogRequestDTO, AxiosResponse<EntityLogDTO>>(
    `/entity/${entityId}/logs/view`,
    { action, entityType }
  );
  return data;
};

const useLogs = () => {
  const { userIsAdmin } = useProtectRoute();
  const { mutateAsync: createViewEntityLogMutation } = useMutation(createViewEntityLog);

  return { createViewEntityLogMutation: userIsAdmin ? createViewEntityLogMutation : () => Promise.resolve() };
};

export default useLogs;
